export const BURGER_MENU_BUTTON_DATA_TEST_ID = "burger-menu-button";
